import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M5.4 6.2H7M5.4 8.6H9M12.928 5.8H10.2a.8.8 0 0 1-.8-.8V2.282"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M13 7.84V6.131a.8.8 0 0 0-.234-.565L9.634 2.434A.8.8 0 0 0 9.07 2.2H4.6A1.6 1.6 0 0 0 3 3.8v8.4a1.6 1.6 0 0 0 1.6 1.6h1.65M12.4 10.2a2.195 2.195 0 0 0-2.116 1.629A1.4 1.4 0 0 0 8.6 13.2a1.4 1.4 0 0 0 1.4 1.4h2.4a2.2 2.2 0 0 0 0-4.4"
    }, null, -1)
  ]))]))
}
export default { render: render }